
<template>
  <div id="content">
    <popup v-show="hasPopup"
           :popup-type="getPopupType"
           :popup-action="getPopupAction"
           @popup-action="executePopupAction"></popup>
    <form autocomplete="off">
      <div class="inner">
        <p class="paging">
          <router-link :to="{ name: moduleName }" class="btn btn_back" v-translate>Seznam</router-link>
        </p>
        <p class="buttons">
          <a v-if="$_deleteActionAllowed && entity.custom_group" class="btn btn_action btn_delete" :title="'Smazat' | translate"
             @click.prevent.stop="deleteEntity" v-translate>Smazat</a>
        </p>
        <h1 v-translate>Přidat nový blokovaný obsah</h1>
      </div>
      <div class="responsiveTabs">
        <div class="tabs_content">
          <section>
            <div class="left">
              <h2 v-translate>Výběr operátora</h2>
            </div>
            <div class="right">
              <div class="field_left">
                <operator-select
                    v-model="operatorIdComputed"
                    :disabled="!allowSelectOperator"
                    :options="operatorOptions"
                    :required="true"
                >
                </operator-select>
              </div>
            </div>
          </section>
          <blackout-content-basic-form
              :entity="entity"
              :is-editable="editable"
              ref="streamprofileformref"
          ></blackout-content-basic-form>
          <section class="buttons">
            <p>
              <router-link :to="{ name: moduleName }" class="btn btn_back btn_seznam" v-translate>Seznam
              </router-link>
              <input type="submit" :value="'Uložit' | translate"
                     v-if="editable"
                     :class="['btn']"
                     @click.prevent.stop="createEntity()">
            </p>
          </section>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import blackoutContents from "./mixins/blackoutContents";
import detailActions from "../../../components/mixins/detail-actions"
import BlackoutContentBasicForm from "./forms/BlackoutContentBasicForm.vue";

export default {
  name: "BlackoutContentNew",
  components: {BlackoutContentBasicForm},
  mixins: [detailActions, blackoutContents],
  data() {
    return {
      getSelectedOperatorAfterLoad: true,
      entityName: "blackout_content",
    }
  },
  created(BlackoutContentService, OperatorService) {
    this.entityService = BlackoutContentService
    this.operatorService = OperatorService
    this.getOperators(true);
    if(this.$_loggedUser_selectedOperatorId){
      this.entity.id_operator = this.$_loggedUser_selectedOperatorId;
    }
  },
  computed: {
    editable() {
      return this.$_updateActionAllowed;
    },
    allowSelectOperator(){
      return this.$_loggedUser_canChangeOperator && this.$_updateActionAllowed && !this.$_loggedUser_selectedOperatorId;
    },
    operatorIdComputed: {
      get() {
        return this.entity.id_operator == null ? '0' : this.entity.id_operator;
      },
      set(newValue) {
        return this.entity.id_operator = newValue
      }
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/views/blackoutContents/BlackoutContentNew.vue